<div class="orderGroup-container ya-typography">
  <div class="ya-page-content ya-page-content--webshop ya-page-content--inset ya-page-content--aligncenter">
    <div class="group-name">
      <div class="icon-container sign title-margin">
        <div class="inline-icon" inlineSVG="shop-icons.svg#ya-hypersoft-gruppencheck"></div>
      </div>
      <div class="group-content">
        <div class="group-info-item">
          <p class="text info-label content-container--subfont text-highlight" [innerHtml]="groupCreatedInfo"></p>
        </div>
        <div class="group-info-item">
          <p class="text content-container--subfont textborder" langkey="phGroupOrder_GroupCreated_State_Info"></p>
        </div>
      </div>
    </div>
    <div class="group-join">
      <div class="icon-container sign">
        <div class="inline-icon" inlineSVG="shop-icons.svg#ya-hypersoft-user-plus"></div>
      </div>
      <div class="group-info-item">
        <p class="text content-container--subfont" langkey="phGroupOrder_GroupCreated_Invite_Friends_Info"></p>
      </div>
      <div class="ya-button-group-wrapper">
        <div class="ya-button-group-container">
          <ng-container *ngIf="isGroupFull$ |async; let isFull then BtnDisable else BtnEnable"></ng-container>
          <ng-template #BtnDisable>
            <div class="botton-wrapper">
              <div class="ya-webshop-button-container">
                <span (click)="OpenWarningGroupFull()">
                  <button mat-flat-button disabled>
                    <span langkey="phGroupOrder_GroupCreated_Invite_Btn"></span>
                  </button>
                </span>
              </div>
            </div>
          </ng-template>
          <ng-template #BtnEnable>
            <div class="ya-webshop-button-container">
              <button mat-flat-button (click)="NavigateToShare()">
                <span langkey="phGroupOrder_GroupCreated_Invite_Btn"></span>
              </button>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
    <div class="webshop-button-wrapper">
      <div class="ya-webshop-button-container webshop-ghost-button">
        <button mat-flat-button (click)="NavigateToMenu()"><span
            langkey="phGroupOrder_GroupCreated_Without_Invite_Btn"></span></button>
      </div>
    </div>
  </div>
</div>